/**
 * Created by boris on 17/07/2018.
 */
angular.module('moebiusProadapt').controller('ctrlSettings', ['$scope', '$rootScope', 'mbsUser', '$location', '$route', '$http', '$window', '$uibModal', 'list',  'moment', 'resource', 'mainFk',
    function($scope, $rootScope, mbsUser, $location, $route, $http, $window, $uibModal, list, moment, resource, mainFk) {

        $scope.autoOpenModal = (_.isUndefined($scope.autoOpenModal)) ? true : $scope.autoOpenModal;

        $scope.modaleTemplateForResource = {
            // "etude-def" : "assets/templates/settings/modals/modal-edition-settings.html",
            "commentaires" : "assets/templates/settings/modals/modal-edition-comment.html",
        };
        $scope.listTemplateForResource = {
            // "etude-def" : "assets/templates/settings/modals/modal-edition-settings.html",
        };
        $scope.detailRouteForResource = {
            "etude-def" : "/etude-def/"
        };

        $scope.getTemplateUrlForResourceForType = function (resource, type) {
            switch (type) {
            case 'modale':
                if (!$scope.modaleTemplateForResource[resource]) {
                    return "assets/templates/settings/modals/modal-edition-settings.html";
                } else {
                    return $scope.modaleTemplateForResource[resource];
                }
                break;
            case 'list':
                if (!$scope.listTemplateForResource[resource]) {
                    if (resource === "commentaires") {
                        return "assets/templates/settings/settings-comment.html";
                    } else {
                        return "assets/templates/settings/settings-table.html";
                    }
                } else {
                    return $scope.listTemplateForResource[resource];
                }
                break;
            default:
                throw ('getTemplateUrlForResourceForType: Unable to find template type ' + type);
            }
        };

        $scope.getDetailRouteForResourceAndItem = function(resource, item) {
            if (!$scope.detailRouteForResource[resource]) {
                return null;
            } else {
                return $scope.detailRouteForResource[resource] + item[$scope.primaryKeyName];
            }
        };

        $scope.goToDetail = function(resource, item) {
            var route = $scope.getDetailRouteForResourceAndItem(resource, item);
            console.log('**************** route ' + route);
            $location.path(route);
        }

        $scope.getTemplateListUrl = function() {
            var resource = $route.current.params.resource;
            return $scope.getTemplateUrlForResourceForType(resource, 'list');
        };

        // -- table data
        $scope.list       = list.data;
        // -- table description
        $scope.form           = list.form.elements;

        if (typeof mbsUser.user !== 'undefined' && $rootScope.userHasRight($rootScope.rights.ADMIN)) {
            $scope.form           = list.form.elements;
        }
        else if (typeof mbsUser.user !== 'undefined' && $rootScope.userHasRole($rootScope.roles.arc_coordinateur)) {
            var allowedFormElementReadOnlyForArc = [
                'id',
                'key',
                'text',
                'name',

                //commentaires
                'created_at',
                'status',
                'zone',
                'zone_key',
                'reponse_ad',
                'valid_at_version'
            ];
            // list.form.elements READONLY
            var disabledElements          = _.each(list.form.elements,function(element) {
                if (allowedFormElementReadOnlyForArc.indexOf(element.name) > -1) {
                    element.disabled = 'disabled';
                }
            });
            disabledElements              = _.filter(disabledElements, function(element) {
                return allowedFormElementReadOnlyForArc.indexOf(element.name) > -1;
            });

            // list.form.elements AVAILABLE
            var allowedFormElementForArc = [
                'text_pour_participant',
                'name_pour_participant',

                //commentaires
                'comment',
                'commentaire',
                'echanges'
            ];
            var arcOnlyElements           = _.filter(list.form.elements,function(element) {
                return allowedFormElementForArc.indexOf(element.name) > -1;
            });

            $scope.form = disabledElements.concat(arcOnlyElements);
            console.log("arc $scope.form", $scope.form);
        }

        $scope.reflection     = list.form.reflection;
        $scope.navigation     = list.form.navigation;
        $scope.nameField      = list.form.nameField;

        //commentaires
        $scope.zoneField      = list.form.hasOwnProperty('zoneField') ? list.form.zoneField : null ;
        $scope.zoneKeyField   = list.form.hasOwnProperty('zoneKeyField') ? list.form.zoneKeyField : null ;
        $scope.statusField    = list.form.hasOwnProperty('statusField') ? list.form.statusField : null ;
        $scope.statusList     = list.form.hasOwnProperty('statusValues') ? list.form.statusValues : null ;

        $scope.primaryKeyName = $scope.reflection.pk;


        // -- resource name
        $scope.resource       = resource;
        $scope.mainFk         = mainFk;

        // -- auto navigation in the list, depending on server response
        if ($scope.navigation) {
            $scope.navigation.forEach(function(el, idx) {
                el.url = function(item) {
                    return el.resource + '?' + el.targetColumn + '=' + item[el.localColumn];
                }

                // for(var i in el) {
                //     el.name = i;
                //     el.url = function(item) {
                //         return el.name + '?' + el[i] + '=' + item[$scope.primaryKeyName];
                //     }
                //     // delete el[i];
                // }

            });
        }


        $scope.ucFirst = function(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        };

        $scope.openEditModal = function(item)
        {
            var scope = $scope.$new();
            scope.resource = resource;
            scope.item = angular.copy(item, {});
            if (!item || !item[$scope.primaryKeyName]) {
                $scope.editOrSave = 'SAVE';
                scope.modalTitle = 'Créer';
                scope.form.forEach(function(el, idx) {
                    scope.form[idx].disabled = '';
                }) ;

                for(var i in $scope.mainFk) {
                    _.find(scope.form, {name: i}).disabled = 'disabled';
                    scope.item[i] = scope.mainFk[i]
                }
            } else {
                $scope.editOrSave = 'EDIT';
                scope.modalTitle = 'Editer';
            }
            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: $scope.getTemplateUrlForResourceForType(resource,'modale'),
                    backdrop: 'static',
                    size: 'lg',
                    scope: scope
                });

            return $scope.modalInstance.result;
        };

        $scope.save = function(item)
        {
            if ($scope.editOrSave === 'SAVE' && $scope.mainFk) {
                for(var i in $scope.mainFk) {
                    item[i] = $scope.mainFk[i];
                }
            }

            item.editOrSave = $scope.editOrSave;

            $http.post(resource, item).then(function(response)
            {
                var index = -1;
                $scope.list.forEach(function (el, idx) {
                    if ( el[$scope.primaryKeyName] === response.data[$scope.primaryKeyName] ) {
                        index = idx;
                    }
                });

                if (index !== -1) {
                    $scope.list[index] = response.data;
                } else {
                    $scope.list.push(response.data);
                }
            }).catch(function (e) {
                console.log(e);
            })
        };

        $scope.delete = function(item)
        {
            var text = 'Confirmer la suppression ?';
            if ($window.confirm(text))
            {
                $http.delete(resource + '/' + item[$scope.primaryKeyName], item)
                    .then(function(response) {

                        var index = -1;
                        $scope.list.forEach(function (el, idx) {
                            if ( el[$scope.primaryKeyName] === response.data[$scope.primaryKeyName] ) {
                                index = idx;
                            }
                        });

                        if (index !== -1) {
                            $scope.list.splice(index, 1);
                        }

                    }).catch(function (e) {
                     console.log(e);
                })
            }
        };


        // -- au bootstrap, si la liste n'a qu'une entrée on ouvre sa modale
        if ($scope.list.length === 1 && $scope.autoOpenModal === true) {
            $scope.openEditModal($scope.list[0]);
        }

        //comments
        $scope.newAuthorInComment = function(commentaire, property) {
            if(commentaire[property] === null || commentaire[property] === "") {
                commentaire[property] = "" ;
            } else {
                commentaire[property] += "\n" ;
            }
            commentaire[property] += moment().format('DD/MM/YYYY') + " " + mbsUser.user.name + " : ";
        };

        console.log('+++++++++++++', $scope);

    }]
);


// WEBPACK FOOTER //
// ./resources/assets/js/controllers/settings/settings.js